export default __webpack_public_path__ + "static/media/diamond@1x.8fe64152.png";